export const MODULE_SELECT_ARIA_KEY = 'MODULE_SELECT_ARIA';
